"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorksheetCard = void 0;
var _LazyLoadImage = _interopRequireDefault(require("apps/teacher/components/common/LazyLoadImage"));
var _react = _interopRequireWildcard(require("react"));
var _downloadButton = _interopRequireDefault(require("./downloadButton.svg"));
var _downloadIcon = _interopRequireDefault(require("./downloadIcon.svg"));
var _IconBookMarkHollow = _interopRequireDefault(require("./IconBookMarkHollow.svg"));
var _IconBookMark = _interopRequireDefault(require("./IconBookMark.svg"));
require("./style.scss");
var _state = require("printableWorksheets/state");
var _printableWorksheets = require("printableWorksheets");
var _events = _interopRequireDefault(require("printableWorksheets/events"));
var PrintableWorksheetsApi = _interopRequireWildcard(require("../../../api"));
var _Button = _interopRequireWildcard(require("printableWorksheets/atoms/Button"));
var _PDFViewer = _interopRequireDefault(require("../../../../teacherDashboard/teacher/components/common/PDFViewer"));
var _useIsInViewport = _interopRequireDefault(require("hooks/useIsInViewport"));
var _wsPreview = _interopRequireDefault(require("../wsPreview"));
var _wsLimitReached = _interopRequireDefault(require("../wsLimitReached"));
var _common = require("apps/teacher/config/common");
var _AppMediaProvider = require("../../../../baseStyles/AppMediaProvider");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var WorksheetCard = function WorksheetCard(_ref) {
  var card = _ref.card,
    isLastCard = _ref.isLastCard;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedPdf = _useState2[0],
    setSelectedPdf = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showWorksheetPreview = _useState4[0],
    setShowWorksheetPreview = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showLimitReachedPopup = _useState6[0],
    setShowLimitReachedPopup = _useState6[1];
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    activeGrade = _usePrintableWorkshee.activeGrade,
    userId = _usePrintableWorkshee.userId,
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment,
    savedWorksheets = _usePrintableWorkshee.savedWorksheets,
    downloadedWorksheets = _usePrintableWorkshee.downloadedWorksheets,
    setDownloadedWorksheets = _usePrintableWorkshee.setDownloadedWorksheets,
    setSavedWorksheets = _usePrintableWorkshee.setSavedWorksheets,
    setSavedCount = _usePrintableWorkshee.setSavedCount,
    setDownloadCount = _usePrintableWorkshee.setDownloadCount;
  var _useAppMediaProvider = (0, _AppMediaProvider.useAppMediaProvider)(),
    isDesktop = _useAppMediaProvider.isDesktop;
  var deepCopyObject = function deepCopyObject(obj) {
    return JSON.parse(JSON.stringify(obj));
  };
  var worksheetCardRef = (0, _react.useRef)();
  (0, _useIsInViewport["default"])(function () {
    if (isLastCard) {
      _events["default"].viewedWorksheetSearchResultsEndPage();
    }
  }, worksheetCardRef);
  var _onSave = function onSave(worksheetDetails) {
    _events["default"].interactedWorksheetListingPage({
      clickedOn: "Saved Worksheet"
    });
    if (worksheetDetails.id && userId) {
      PrintableWorksheetsApi.postUserSavedCollection({
        userId: userId,
        params: {
          entity_id: worksheetDetails.id,
          entity_type: 'SearchContent'
        }
      }).then(function () {
        var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        savedWorksheets[worksheetDetails === null || worksheetDetails === void 0 ? void 0 : worksheetDetails.id] = result.user_collection_entity || {};
        setSavedWorksheets(deepCopyObject(savedWorksheets));
        setSavedCount(function (savedCount) {
          return savedCount + 1;
        });
        showFlashMessage('Worksheet saved successfully', 'success');
        window.dispatchEvent(new CustomEvent('saved-worksheets-update'));
        _events["default"].savedWorksheet({
          worksheetGrade: activeGrade,
          worksheetCategory: "",
          worksheetSubcategory: "",
          from: selectedPdf ? "Preview" : "Worksheet Listing Page"
        });
      });
    }
  };
  var previewWorksheet = function previewWorksheet(card) {
    _events["default"].interactedWorksheetListingPage({
      clickedOn: "Preview Clicked"
    });
    _events["default"].previewedWorksheet({
      worksheetName: card.title,
      worksheetGrade: activeGrade,
      worksheetCategory: "",
      worksheetSubcategory: ""
    });
    setSelectedPdf(card);
  };
  var onUnSave = function onUnSave(entity_id) {
    _events["default"].interactedWorksheetListingPage({
      clickedOn: "UnSave Clicked"
    });
    if (entity_id && userId) {
      var _savedWorksheets$enti;
      PrintableWorksheetsApi.deleteUserCollection({
        userId: userId,
        id: (_savedWorksheets$enti = savedWorksheets[entity_id]) === null || _savedWorksheets$enti === void 0 ? void 0 : _savedWorksheets$enti.id
      }).then(function () {
        var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        delete savedWorksheets[entity_id];
        setSavedWorksheets(deepCopyObject(savedWorksheets || {}));
        setSavedCount(function (savedCount) {
          return savedCount - 1;
        });
        showFlashMessage('Worksheet unsaved successfully', 'success');
        window.dispatchEvent(new CustomEvent('saved-worksheets-update'));
      });
    }
  };
  var _onDownload = function onDownload() {
    _events["default"].interactedWorksheetListingPage({
      clickedOn: "Download Worksheet"
    });
    if (card.id && userId) {
      // GlobalSpinner.show();
      fetch(card.pdf_url, {
        credentials: 'omit'
      }).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        // GlobalSpinner.hide();
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = card.title;
        a.target = '_system';
        a.click();
        a.remove();
        if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
          PrintableWorksheetsApi.postSaveUserDownload({
            userId: userId,
            params: {
              entity_id: card.id,
              entity_type: 'SearchContent'
            },
            callback: function callback() {
              var _window;
              showFlashMessage('Worksheet downloaded successfully', 'success');
              if (!downloadedWorksheets.find(function (ws) {
                return ws.id === card.id;
              })) {
                setDownloadedWorksheets(function (dws) {
                  return [].concat(_toConsumableArray(dws), [card]);
                });
                setDownloadCount(function (downloadCount) {
                  return downloadCount + 1;
                });
              }
              (_window = window) === null || _window === void 0 ? void 0 : _window.dispatchEvent(new CustomEvent('download-worksheets-update'));
              var props = {
                worksheetName: card.title,
                worksheetGrade: activeGrade.toLowerCase(),
                worksheetCategory: "",
                worksheetSubcategory: "",
                from: "Worksheet Listing Page"
              };
              _events["default"].downloadedWorksheet(props);
            }
          });
        }
      })["catch"](function (e) {
        // sendErrorToSentry(new Error("Worksheet download failed"), card)
      });
    }
  };
  var onWorksheetCardClick = function onWorksheetCardClick() {
    if (isDesktop) {
      if ((0, _common.canDownloadWs)()) {
        setShowWorksheetPreview(true);
      } else {
        setShowLimitReachedPopup(true);
      }
      if (window.parent.triggerIsFlutterHeaderClickDisabled) {
        window.parent.triggerIsFlutterHeaderClickDisabled();
      }
    } else {
      window.open(card === null || card === void 0 ? void 0 : card.pdf_url);
      _events["default"].downloadedWorksheetB2c({
        worksheetName: card.title,
        worksheetCode: card.code
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showWorksheetPreview && /*#__PURE__*/_react["default"].createElement(_wsPreview["default"], {
    worksheetDetails: card,
    setShowWorksheetPreview: setShowWorksheetPreview,
    showWorksheetPreview: showWorksheetPreview
  }), showLimitReachedPopup ? /*#__PURE__*/_react["default"].createElement(_wsLimitReached["default"], {
    worksheetDetails: card,
    setShowLimitReachedPopup: setShowLimitReachedPopup
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "worksheet-card ".concat(worksheetsEnvironment),
    ref: worksheetCardRef,
    onClick: function onClick() {
      if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD) {
        _events["default"].interactedWorksheetListingPage({
          clickedOn: "Worksheet Card"
        });
        onWorksheetCardClick();
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "img-container",
    onClick: function onClick() {
      worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD && previewWorksheet(card);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-img-container"
  }, worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? /*#__PURE__*/_react["default"].createElement(_LazyLoadImage["default"], {
    src: card.image_url,
    alt: "worksheetImage"
  }) : /*#__PURE__*/_react["default"].createElement("img", {
    src: card.image_url,
    alt: "worksheetImage"
  }), worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "preview",
    onClick: function onClick() {
      return previewWorksheet(card);
    }
  }, /*#__PURE__*/_react["default"].createElement("button", null, "Preview")) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "actions"
  }, worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD ? /*#__PURE__*/_react["default"].createElement("a", {
    className: "download-button"
  }, /*#__PURE__*/_react["default"].createElement(_downloadButton["default"], null)) : null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "info-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "details"
  }, worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title",
    title: card.title
  }, card.title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "meta_description"
  }, card.description), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cta-container"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: _Button.ButtonTypes.primary,
    onClick: _onDownload,
    className: "custom-download-btn"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icn-container"
  }, /*#__PURE__*/_react["default"].createElement(_downloadIcon["default"], null)), "Download"), /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick() {
      return savedWorksheets[card.id] ? onUnSave(card.id) : _onSave(card);
    },
    className: "bookmark-button ".concat(savedWorksheets[card.id] ? 'active' : '')
  }, !savedWorksheets[card.id] ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_IconBookMarkHollow["default"], null), " ", /*#__PURE__*/_react["default"].createElement("label", null, "Saved")) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_IconBookMark["default"], null), " ", /*#__PURE__*/_react["default"].createElement("label", null, "Save")), " "))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "meta_description st-ws"
  }, card.title)))), selectedPdf && selectedPdf.pdf_url && /*#__PURE__*/_react["default"].createElement(_PDFViewer["default"], {
    title: selectedPdf === null || selectedPdf === void 0 ? void 0 : selectedPdf.title,
    subtitle: selectedPdf === null || selectedPdf === void 0 ? void 0 : selectedPdf.meta_description,
    file: selectedPdf === null || selectedPdf === void 0 ? void 0 : selectedPdf.pdf_url,
    onBack: function onBack() {
      return setSelectedPdf(null);
    },
    onSave: function onSave() {
      return _onSave(selectedPdf);
    },
    onUnsave: function onUnsave() {
      return onUnSave(selectedPdf === null || selectedPdf === void 0 ? void 0 : selectedPdf.id);
    },
    onDownload: function onDownload() {
      return _onDownload();
    },
    isSaved: savedWorksheets[selectedPdf === null || selectedPdf === void 0 ? void 0 : selectedPdf.id]
  })));
};
exports.WorksheetCard = WorksheetCard;